export default "__VITE_ASSET__BYUcRBqu__"